import React from "react";

export default function SupportPage() {
  return (
    <div className="min-vh-100 bg-light py-5 px-4 d-flex flex-column align-items-center">
      <div className="container bg-white shadow-lg rounded-4 p-5 my-4" style={{ maxWidth: "900px" }}>
        <h1 className="display-5 fw-bold mb-4 text-dark border-bottom pb-3">Support</h1>

        <p className="text-secondary lh-lg fs-5 mb-5">
          Welcome to the Field Agent Tracking support center. If you are facing
          any issues related to login, tracking, attendance, or app
          functionality, our support team is here to help.
        </p>

        <div className="row g-4 mb-5">
          <div className="col-md-6">
            <div className="border rounded-4 p-4 h-100 shadow-sm">
              <h2 className="h4 fw-semibold mb-3 text-dark">Email Support</h2>
              <p className="text-secondary mb-2">
                Contact our support team via email.
              </p>
              <p className="fw-bold text-primary fs-5 mb-0">ftprovip@gmail.com</p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="border rounded-4 p-4 h-100 shadow-sm">
              <h2 className="h4 fw-semibold mb-3 text-dark">Working Hours</h2>
              <p className="text-secondary mb-0 lh-lg">
                Monday to Saturday
                <br />
                <span className="fw-medium text-dark">9:00 AM – 6:00 PM</span>
              </p>
            </div>
          </div>
        </div>

        <div className="d-flex flex-column gap-5">
          <div>
            <h2 className="h3 fw-semibold mb-3 text-dark">Common Issues</h2>
            <ul className="mb-0 ps-4 text-secondary fs-6 lh-lg">
              <li className="mb-2">Location tracking not updating</li>
              <li className="mb-2">Attendance not marking correctly</li>
              <li className="mb-2">Login or password related issues</li>
              <li className="mb-2">Task synchronization delays</li>
              <li className="mb-2">Background tracking permissions</li>
            </ul>
          </div>

          <div>
            <h2 className="h3 fw-semibold mb-3 text-dark">Troubleshooting</h2>
            <ul className="mb-0 ps-4 text-secondary fs-6 lh-lg">
              <li className="mb-2">Ensure location permission is enabled</li>
              <li className="mb-2">Keep internet connection active</li>
              <li className="mb-2">Allow background app refresh</li>
              <li className="mb-2">Update the app to the latest version</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
